var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2722_11505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.03718 14.0216C9.06951 14.0216 9.90639 13.1847 9.90639 12.1524C9.90639 11.1201 9.06951 10.2832 8.03718 10.2832C7.00484 10.2832 6.16797 11.1201 6.16797 12.1524C6.16797 13.1847 7.00484 14.0216 8.03718 14.0216Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5061 7.64889C12.4784 7.62038 12.4491 7.59495 12.4206 7.56875L12.3366 7.48939C12.3227 7.47476 12.3073 7.46397 12.2896 7.4501C9.87258 5.2542 6.17346 5.34127 3.86661 7.64812L3.59617 7.91933L3.22171 8.29379C2.76558 8.74992 2.76789 9.49344 3.22479 9.95034C3.68246 10.4088 4.42598 10.4096 4.88134 9.95342L5.52701 9.30775C6.99403 7.84151 9.38024 7.84151 10.8465 9.30698L11.3126 9.75849C11.7641 10.21 12.5007 10.2092 12.9545 9.75464C13.1741 9.53582 13.2951 9.2438 13.2959 8.93329C13.2966 8.62433 13.1772 8.33231 12.9576 8.11426L12.5061 7.64889Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6896 5.33802L15.3013 4.94969C15.2997 4.94815 15.299 4.94584 15.2959 4.94507L14.9892 4.63687C14.9353 4.58371 14.8767 4.53748 14.8151 4.49741C10.8756 1.03868 4.88347 1.14501 1.06954 4.81408C1.05105 4.83104 1.03025 4.84259 1.01176 4.86108L0.310609 5.563C-0.105455 5.9783 -0.103144 6.65402 0.315232 7.07239C0.732838 7.49 1.40856 7.49308 1.82462 7.07624L2.52577 6.37587C2.53039 6.3697 2.53424 6.36431 2.53887 6.36046C5.62314 3.38097 10.5158 3.36248 13.6247 6.29959L14.1764 6.85203C14.5916 7.26733 15.2689 7.26578 15.6865 6.84818C16.1033 6.4298 16.1049 5.75331 15.6896 5.33802Z",
    fill: ""
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2722_11505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.a6f513199362bd946ad2fa6ea9cac306.svg";
export { ForwardRef as ReactComponent };